import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject, cleanupClassNames } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp, fRef } from '../../utils/React.js';
import { getGridClasses } from '../Grid/GridPresentation.js';
import { getGridColumnClasses, getGridColumnInnerClasses } from '../GridColumn/GridColumnPresentation.js';
import { GridRowPresentation } from '../GridRow/GridRowPresentation.js';
import { SliderPaginationPresentation } from '../SliderPagination/SliderPaginationPresentation.js';
import { hostClass } from './GallerySlider.styles.js';

var defaultProps = {
  slidesToDisplay: 3
}; // Hack to get rid of forwardRefs

var Div = fRef(function (_a) {
  var ref = _a.ref,
      props = __rest(_a, ["ref"]);

  return /*#__PURE__*/React.createElement("div", Object.assign({}, props, {
    ref: ref
  }));
});
var GallerySliderPresentation = fComp(function (props) {
  var _cleanupClassObject;

  var id = props.id,
      animation = props.animation,
      animationOffset = props.animationOffset,
      animationDirection = props.animationDirection,
      translate = props.translate,
      children = props.children,
      className = props.className,
      activeDot = props.activeDot,
      dotCount = props.dotCount,
      noMargin = props.noMargin,
      isStencilHost = props.isStencilHost,
      outerRef = props.outerRef,
      _onMouseDown = props.onMouseDown,
      _onDragStart = props.onDragStart,
      someElementRef = props.someElementRef,
      handlePointClick = props.handlePointClick,
      handleArrowLeftClick = props.handleArrowLeftClick,
      handleArrowRightClick = props.handleArrowRightClick,
      currentSlide = props.currentSlide,
      slidesToDisplay = props.slidesToDisplay,
      look = props.look;
  var md = 12 / slidesToDisplay;
  var sm = 8 / Math.max(slidesToDisplay - 1, 1);
  var xs = 4;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassNames([getGridClasses({
      spacing: "doublesubsection",
      gallerySliderSpacing: !look
    }), "".concat(hostClass, "-outer"), currentSlide > 0 && "".concat(hostClass, "-outer__notfirst"), animation && "".concat(hostClass, "-outer__animate")]),
    onMouseDown: function onMouseDown(e) {
      return _onMouseDown(e);
    },
    onTouchStart: function onTouchStart(e) {
      return _onMouseDown(e);
    },
    onDragStart: function onDragStart(e) {
      return _onDragStart(e);
    },
    onSelect: function onSelect(e) {
      return _onDragStart(e);
    },
    ref: outerRef
  }, /*#__PURE__*/React.createElement(GridRowPresentation, null, React.Children.map(children, function (child, i) {
    return /*#__PURE__*/React.createElement(Div, {
      style: {
        transform: "translateX(-".concat(translate, ") translateZ(0)"),
        transition: animation ? "transform ".concat(0.1 * (animationOffset + i * animationDirection), "s") : "unset"
      },
      ref: someElementRef,
      key: child.key,
      className: getGridColumnClasses({
        xs: xs,
        sm: sm,
        md: md
      })
    }, /*#__PURE__*/React.cloneElement(child, {
      look: look,
      className: getGridColumnInnerClasses({})
    }));
  }))), /*#__PURE__*/React.createElement(SliderPaginationPresentation, {
    numDots: dotCount,
    activeDotIndex: activeDot,
    onPointClick: handlePointClick,
    onArrowLeftClick: handleArrowLeftClick,
    onArrowRightClick: handleArrowRightClick,
    arrowIcon: true
  }));
}, defaultProps);

export { GallerySliderPresentation, defaultProps };
